import { Workspace } from "@/domain/workspace/models/workspace-model";

import { ClimateAction } from "../models/climate-action";

export const makeClimateActionUrl = ({
  workspace,
  climateAction,
  path,
}: {
  workspace: Workspace;
  climateAction: ClimateAction;
  path: string;
}) => {
  return `/${workspace.workspaceUrl}/climate-actions/${climateAction.id}/${path}`;
};
